
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'GroupLevelFrontCard',
  props: ['thisGroup'],
  setup(props) {
    const group = ref(props.thisGroup);
    return {
      group,
    };
  },
});
